// extracted by mini-css-extract-plugin
export default {"link":"Twhikb","handle":"vAywPM","name":"LLq_0k","next":"LtDP2O"};